const env = process.env.NODE_ENV || "development";

const domainEnvironment = {
  development: {
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName:"",
  },
  production: {
      domainAdminSide: "https://admin.dabac.cgis.asia",
      domainUserSide: "https://dabac.cgis.asia",
      domainName:"dabac.cgis.asia",
  },
};

module.exports = domainEnvironment[env];
